import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Menus from "./menus";
import { useSelector } from "react-redux";
import { BASEURL } from "../config";
import axios from "axios";
import Landing from "../pages/home/landing";
import ContactUs from "../pages/contact/contactUs";
import SkeletonComponent from "../components/skeletonLoader";
import WhatsAppWidget from "../pages/WhatsAppWidget/WhatsAppWidget";

import Login from "../pages/login/login";
import Faq from "../pages/faq/faq";

const Router = () => {
  const { validate, login } = useSelector((state) => {
    return state;
  });
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const navigate = useNavigate();
  axios.defaults.baseURL = BASEURL;
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${validate?.payload?.message?.token}`;
  axios.interceptors.request.use(
    (request) => {
      return request;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  function Redirect({ to }) {
    useEffect(() => {
      navigate(to); // Use navigate() to handle redirection
    }, [to, navigate]);

    return null;
  }
  return (
    <>
      {/* {load ? <SkeletonComponent /> : (!validate?.payload?.success ? ( */}
      {login?.loading ? (
        <SkeletonComponent />
      ) : !userInfo?.access_token ? (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Redirect to="/" />} />
          <Route path="/contact-us" exact element={<ContactUs />} />
          <Route path="/faq" exact element={<Faq />} />
          <Route path="/" exact element={<Landing />} />
        </Routes>
      ) : (
        <Menus />
      )}
      <WhatsAppWidget />
    </>
  );
};
export default Router;
